
import "../CreateClient/CreateClient.css";
import React, { Dispatch, useEffect } from "react";
import { baseURL } from "../../constants";
import { deleteAttachment } from "../../api";
import ClearIcon from '@mui/icons-material/Clear';

type propsData = {
    profilePicture: File[] | null,
    companyLogo: File[] | null,
    personalLogo: File[] | null,
    additionalImages: File[] | null,
    showProfilePicture: string[] | null,
    showPersonalLogo : string[] | null,
    showCompanyLogo : string[] | null,
    showAdditionalImage: string[] | null,
    setProfilePicture: Dispatch<React.SetStateAction<File[]>>,
    setPersonalLogo: Dispatch<React.SetStateAction<File[]>>,
    setCompanyLogo: Dispatch<React.SetStateAction<File[]>>,
    setAdditionalImages: Dispatch<React.SetStateAction<File[]>>,
    setShowProfilePicture:  Dispatch<React.SetStateAction<any[]>>,
    setShowPersonalLogo: Dispatch<React.SetStateAction<any[]>>,
    setShowCompanyLogo: Dispatch<React.SetStateAction<any[]>>,
    setShowAdditionalImage: Dispatch<React.SetStateAction<any[]>>,
    client: any
}

function AddClientImages(props: propsData) {

    const {
        showProfilePicture,
        showPersonalLogo,
        showCompanyLogo,
        showAdditionalImage,
        setProfilePicture,
        setPersonalLogo,
        setCompanyLogo,
        setAdditionalImages,
        setShowProfilePicture,
        setShowPersonalLogo,
        setShowCompanyLogo,
        setShowAdditionalImage,
        client
    } = props

    useEffect(() => {
        if (client) {
            client.attachments.forEach((image: { id: number, url: string, attachmentType: string } ) => {
                if (image.attachmentType === "PROFILE_PICTURE") {
                    setShowProfilePicture((showProfilePicture: any[]) => { return [ ...showProfilePicture, image ] } )
                }
                else if (image.attachmentType === "PERSONAL_LOGO") {
                    setShowPersonalLogo((showPersonalLogo: any[]) => { return [ ...showPersonalLogo, image ] } )
                }
                else if (image.attachmentType === "COMPANY_LOGO") {
                    setShowCompanyLogo((showCompanyLogo: any[]) => { return [ ...showCompanyLogo, image ] } )
                }
                else {
                    setShowAdditionalImage((showAdditionalImage: any[]) => { return [ ...showAdditionalImage, image ] })
                }
            })
        }
    }, [client])

    const profilePicHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const files = e.target.files;
        let reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setShowProfilePicture((showProfilePicture: any[]) => {
                    return [ ...showProfilePicture, reader.result ];
                })
            }
        }
        if (files) {
            setProfilePicture((profilePicture: File[]) => {
                return [ ...profilePicture, files[0] ];
            })
            reader.readAsDataURL(files[0]);
        }
    }

    const personalLogoHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const files = e.target.files;
        let reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setShowPersonalLogo((showPersonalLogo: any[]) => {
                    return [ ...showPersonalLogo, reader.result ];
                })
            }
        }

        if (files) {
            setPersonalLogo((personalLogo: File[]) => {
                return [ ...personalLogo, files[0] ];
            })
            reader.readAsDataURL(files[0]);
        }
    }

    const companyLogoHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const files = e.target.files;
        let reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setShowCompanyLogo((showCompanyLogo: any[]) => {
                    return [ ...showCompanyLogo, reader.result ];
                })
            }
        }
        if (files) {
            setCompanyLogo((companyLogo: File[]) => {
                return [ ...companyLogo, files[0] ];
            })
            reader.readAsDataURL(files[0]);
        }
    }

    const additionalFotoHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const files = e.target.files;
        let reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setShowAdditionalImage((showAdditionalImage: any[]) => {
                    return [ ...showAdditionalImage, reader.result ];
                })
            }
        }
        if (files) {
            setAdditionalImages((additionalImages: File[]) => {
                return [ ...additionalImages, files[0] ];
            })
            reader.readAsDataURL(files[0]);
        }
    }

    const deleteProfilePicture = async (ind: number, picture: any) => {
        setProfilePicture((profilePicture: File[]) => profilePicture.filter((item: File, index: number) => index !== ind));
        setShowProfilePicture((showProfilePicture: any[]) => showProfilePicture.filter((item: any, index: number) => index !== ind));
        if (picture.id) {
            try {
                await deleteAttachment(picture.id);
            }
            catch (error) {
                console.log(error);
            }
        }
    }

    const deletePersonalLogo = async(ind: number, picture: any) => {
        setPersonalLogo((profilePicture: File[]) => profilePicture.filter((item: File, index: number) => index !== ind));
        setShowPersonalLogo((showProfilePicture: any[]) => showProfilePicture.filter((item: any, index: number) => index !== ind));
        if (picture.id) {
            try {
                const deleteData = await deleteAttachment(picture.id);
                console.log(deleteData);
            }
            catch (error) {
                console.log(error);
            }
        }
    }

    const deleteCompanyLogo = async (ind: number, picture: any) => {
        setCompanyLogo((profilePicture: File[]) => profilePicture.filter((item: File, index: number) => index !== ind));
        setShowCompanyLogo((showProfilePicture: any[]) => showProfilePicture.filter((item: any, index: number) => index !== ind));
        if (picture.id) {
            try {
                await deleteAttachment(picture.id);
            }
            catch (error) {
                console.log(error);
            }
        }
    }

    const deleteAdditionalImage= async (ind: number, picture: any) => {
        setAdditionalImages((profilePicture: File[]) => profilePicture.filter((item: File, index: number) => index !== ind));
        setShowAdditionalImage((showProfilePicture: any[]) => showProfilePicture.filter((item: any, index: number) => index !== ind));
        if (picture.id) {
            try {
                const deleteData = await deleteAttachment(picture.id);
                console.log(deleteData);
            }
            catch (error) {
                console.log(error);
            }
        }
    }

    return(
        <div className="AddClientImages">
            <div className="addClientImagesHead">
                <span>Profile Pictures</span>
                <span>Personal Logos</span>
                <span>Company Logos</span>
                <span>Additional Images </span>
            </div>
            <div className="allImagesBox">
                <div className="addClientPictureBox">
                    {
                        showProfilePicture!.map((picture: any, index: number) => {
                            return <div key = { index } className="addimageExampleBox">
                                <div className="concretImageBox">
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ index + 1 } Profile Picture</span>
                                        <span className="addFileBtn">
                                            <input
                                                type = "file"
                                                className = "addFileInput"
                                            />
                                            Choose File
                                        </span>
                                    </div>
                                    <div className="concretImageNameBox">
                                        <img
                                            className = "addNewImage"
                                            src = { picture.id ? `${baseURL}/attachments?name=${picture.url}` : picture }
                                            alt = { "image" }
                                        />
                                    </div>
                                </div>
                                <div className="newImageNameAndDeleteBox">
                                    <span
                                        style = {{
                                            color: "#999",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "85%",
                                            display: "inline-block",
                                        }}
                                    >
                                    </span>
                                    <ClearIcon
                                        style = {{
                                            color: "#999",
                                            cursor: "pointer",
                                        }}
                                        onClick = { () => deleteProfilePicture(index, picture) }
                                    />
                                </div>
                            </div>
                        })
                    }
                    {
                        showProfilePicture!.length < 3 &&
                        <div className="addimageExampleBox">
                            <div className="concretImageBox">
                                <div className="concretImageButtonAndFotoBox">
                                    <span>{ showProfilePicture!.length + 1 } Profile Picture </span>
                                    <span className="addFileBtn">
                                        <input
                                            type = "file"
                                            className = "addFileInput"
                                            onChange = { (e) => profilePicHandler(e) }
                                        />
                                        Choose File
                                        </span>
                                </div>
                                <div className="concretImageNameBox">

                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className="addClientPictureBox">
                    {
                        showPersonalLogo!.map((picture: any, index: number) => {
                            return <div key = { index } className="addimageExampleBox">
                                <div className="concretImageBox" key={ index } >
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ index + 1 } Personal Logo</span>
                                        <span className="addFileBtn">
                                            <input
                                                type="file"
                                                className="addFileInput"
                                            />
                                            Choose File
                                        </span>
                                    </div>
                                    <div className="concretImageNameBox">
                                        <img
                                            className = "addNewImage"
                                            src = { picture.id ? `${baseURL}/attachments?name=${picture.url}` : picture }
                                            alt = { "image" }
                                        />
                                    </div>
                                </div>
                                <div className="newImageNameAndDeleteBox">
                                    <span
                                        style = {{
                                            color: "#999",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "85%",
                                            display: "inline-block",
                                        }}
                                    >
                                    </span>
                                    <ClearIcon
                                        style = {{
                                            color: "#999",
                                            cursor: "pointer",
                                        }}
                                        onClick = { () => deletePersonalLogo(index, picture) }
                                    />
                                </div>
                            </div>
                        })
                    }
                    {
                        showPersonalLogo!.length < 3 &&
                        <div className="addimageExampleBox">
                            <div className="concretImageBox">
                                <div className="concretImageButtonAndFotoBox">
                                    <span>{ showPersonalLogo!.length + 1 } Personal Logo </span>
                                    <span className="addFileBtn">
                                        <input
                                            type = "file"
                                            className = "addFileInput"
                                            onChange = { personalLogoHandler }
                                        />
                                        Choose File
                                        </span>
                                </div>
                                <div className="concretImageNameBox">

                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className="addClientPictureBox">
                    {
                        showCompanyLogo!.map((picture: any, index: number) => {
                                return <div key = { index } className = "addimageExampleBox">
                                    <div className = "concretImageBox" key = { index }>
                                        <div className = "concretImageButtonAndFotoBox">
                                            <span>{ index + 1 } Company Logo</span>
                                            <span className = "addFileBtn">
                                            <input
                                                type = "file"
                                                className = "addFileInput"
                                            />
                                            Choose File
                                        </span>
                                        </div>
                                        <div className = "concretImageNameBox">
                                            <img
                                                className = "addNewImage"
                                                src = { picture.id ? `${baseURL}/attachments?name=${picture.url}` : picture }
                                                alt = { "image" }
                                            />
                                        </div>
                                    </div>
                                    <div className = "newImageNameAndDeleteBox">
                                    <span
                                        style = {{
                                            color: "#999",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "85%",
                                            display: "inline-block",
                                        }}
                                    >
                                    </span>
                                        <ClearIcon
                                            style = {{
                                                color: "#999",
                                                cursor: "pointer",
                                            }}
                                            onClick = { () => deleteCompanyLogo(index, picture) }
                                        />
                                    </div>
                                </div>
                            }
                        )
                    }
                    {
                        showCompanyLogo!.length < 3 &&
                        <div className = "addimageExampleBox">
                            <div className = "concretImageBox">
                                <div className = "concretImageButtonAndFotoBox">
                                    <span>{ showCompanyLogo!.length + 1 } Company Logo</span>
                                    <span className = "addFileBtn">
                                        <input
                                            type = "file"
                                            className = "addFileInput"
                                            onChange = { companyLogoHandler }
                                        />
                                        Choose File
                                    </span>
                                </div>
                                <div className = "concretImageNameBox">

                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className = "addClientPictureBox">
                    {
                        showAdditionalImage!.map((picture: any, index: number) => {
                            return <div key = { index } className="addimageExampleBox">
                                <div className="concretImageBox" key = { index }>
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ index + 1 } Additional Image</span>
                                        <span className="addFileBtn">
                                            <input
                                                type="file"
                                                className="addFileInput"
                                            />
                                            Choose File
                                        </span>
                                    </div>
                                    <div className="concretImageNameBox">
                                        <img className="addNewImage" src = { picture.id ? `${baseURL}/attachments?name=${picture.url}` : picture } alt={"image"}/>
                                    </div>
                                </div>
                                <div className="newImageNameAndDeleteBox">
                                    <span
                                        style = {{
                                            color: "#999",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "85%",
                                            display: "inline-block",
                                        }}
                                    >
                                    </span>
                                    <ClearIcon
                                        style = {{
                                            color: "#999",
                                            cursor: "pointer",
                                        }}
                                        onClick = { () => deleteAdditionalImage(index, picture) }
                                    />
                                </div>
                            </div>
                        })
                    }
                    {
                        showAdditionalImage!.length < 3 &&
                        <div className="addimageExampleBox">
                            <div className="concretImageBox">
                                <div className="concretImageButtonAndFotoBox">
                                    <span>{ showAdditionalImage!.length + 1 } Additional Image</span>
                                    <span className="addFileBtn">
                                            <input
                                                type = "file"
                                                className = "addFileInput"
                                                onChange = { additionalFotoHandler }
                                            />
                                            Choose File
                                        </span>
                                </div>
                                <div className="concretImageNameBox">

                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default AddClientImages